// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2dPNJ","footer":"ModalInfo_footer__2hab-"};